<script lang="ts">
  /** Cover = obere Hälfte der ersten Notenseite (serverseitiges Thumbnail). */
  let {
    src,
    alt = "",
    ratio = "4 / 5",
    radius = "10px",
    transitionName = "",
  }: { src: string; alt?: string; ratio?: string; radius?: string; transitionName?: string } = $props();
  let loaded = $state(false);
  let failed = $state(false);
</script>

<div
  class="cover"
  class:loaded
  style:aspect-ratio={ratio}
  style:border-radius={radius}
  style:view-transition-name={transitionName || null}
>
  {#if !failed}
    <img
      {src}
      {alt}
      loading="lazy"
      decoding="async"
      onload={() => (loaded = true)}
      onerror={() => (failed = true)}
    />
  {/if}
</div>

<style>
  .cover {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: var(--paper);
    box-shadow: var(--shadow-1);
  }
  .cover::before {
    /* Platzhalter: angedeutete Notenlinien, bis das Bild da ist */
    content: "";
    position: absolute;
    inset: 22% 14% auto;
    height: 46%;
    background: repeating-linear-gradient(#c9c4b8 0 1px, transparent 1px 5px);
    background-size: 100% 25px;
    opacity: 0.6;
  }
  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    opacity: 0;
    transition:
      opacity var(--dur-base) var(--ease-out),
      transform var(--dur-sheet) var(--ease-spring);
  }
  .loaded img {
    opacity: 1;
  }
  :global(.cover-zoom:hover) img,
  :global(.cover-zoom:focus-visible) img {
    transform: scale(1.05);
  }
</style>
